import styled from 'styled-components';
import { media, layout, colorUtils } from '@prisjakt/ui-base';

import Magnify from 'mdi-react/MagnifyIcon';

const ITEM_HEIGHT = '40px';

type ItemProps = { selected?: boolean; disabled?: boolean };

export const Item = styled.li<ItemProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${ITEM_HEIGHT};
  padding-left: ${layout.measurements.spacingNormal};
  padding-right: ${layout.measurements.spacingNormal};
  background: ${p => (p.selected ? 'rgba(72,149,182,0.1)' : 'transparent')};
  opacity: ${p => (p.disabled ? 0.3 : 1)};

  &:hover {
    background: ${p => colorUtils.setRgbaAlpha(p.theme.colors.base800, '0.04')};
  }

  ${media.smallOnly`
    border-bottom: 1px solid ${p => p.theme.colors.base200};
  `}
`;

export const IconWrapper = styled.span`
  width: 30px;
  height: ${ITEM_HEIGHT};
  margin-right: ${layout.measurements.spacingSmall};
  display: flex;
  align-items: center;
`;

export const RowInfo = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DirectLink = styled.span`
  color: ${p => p.theme.colors.base400};
  font-size: 12px;
  padding-left: ${layout.measurements.spacingNormal};
`;

type IconProps = { storeLogo?: boolean };

export const Icon = styled.img<IconProps>`
  width: ${p => (p.storeLogo ? '50px' : '25px')};
  height: ${p => (p.storeLogo ? 'auto' : '25px')};
`;

type OriginalQueryProps = { selected?: boolean };

export const OriginalQuery = styled.div<OriginalQueryProps>`
  padding: 0;
  margin-bottom: 5px;
  font-size: 16px;
  border-bottom: 1px solid
    ${p => (p.selected ? 'transparent' : p.theme.colors.base200)};
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  ${media.smallOnly`
    border-bottom: none;
  `}
`;

export const ExtendSearch = styled.span``;

export const SearchIcon = styled(Magnify)`
  path {
    fill: ${p => p.theme.colors.base300};
  }
`;
